import { ISearchQuery } from '@view-models/interfaces/search-query';
import { FilterBy, IFilterBy, ISortBy, SortBy } from '@services/cleanfill-api/cleanfill-api.generated';

export class SearchQuery implements ISearchQuery {
  Page: number;
  PageSize: number;
  FilterBy: FilterBy[];
  SortBy: FilterBy[];

  constructor() {
    this.Page = 1;
    this.PageSize = 10;
    this.FilterBy = [];
    this.SortBy = [];
  }

  setPageIndex(n: number): SearchQuery {
    this.Page = n;
    return this;
  }

  setPageSize(n: number): SearchQuery {
    this.PageSize = n;
    return this;
  }

  appendFilterBy(filter: IFilterBy): SearchQuery {
    const filters = this.FilterBy.slice();
    filters.push(new FilterBy(filter));
    this.FilterBy = filters;
    return this;
  }

  appendSortBy(sort: ISortBy): SearchQuery {
    const sorters = this.SortBy.slice();
    sorters.push(new SortBy(sort));
    this.SortBy = sorters;
    return this;
  }
}
